import { Link, Text } from '@fly/core';
import { Separator, Skeleton } from '@radix-ui/themes';
import classNames from 'classnames';

import { FlyAccordion } from '../FlyAccordion/FlyAccordion';

export const InsightItem = ({
  icon,
  content,
  className,
  loading = false,
  inset = false,
  href,
  target,
  rel,
}: {
  icon?: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  loading?: boolean;
  inset?: boolean;
  href?: string;
  target?: string;
  rel?: string;
}) => {
  const element = (
    <Skeleton loading={loading}>
      <div
        className={classNames(
          'min-h-5 flex w-full gap-fly-3',
          !inset && 'pl-fly-4',
          className
        )}
      >
        {!!icon && (
          <div className='h-5 flex items-center text-custom-12'>{icon}</div>
        )}
        <Text size='2' className='w-full' highContrast={!href}>
          {content}
        </Text>
      </div>
    </Skeleton>
  );

  if (href) {
    return (
      <Link href={href} target={target} rel={rel} className='w-full'>
        {element}
      </Link>
    );
  }

  return element;
};

export const InsightGroup = ({
  title,
  items,
  className,
}: {
  title: string;
  items: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={classNames('flex flex-col gap-fly-3', className)}>
      <span className='font-semibold pl-fly-3 text-size-fly-3'>{title}</span>
      <div className='flex flex-col items-start gap-fly-3'>{items}</div>
      <Separator size='4' />
    </div>
  );
};

export const Insights = ({
  asAccordion = false,
  items,
  title = 'Insights',
}: {
  asAccordion?: boolean;
  items: React.ReactNode[];
  title?: React.ReactNode;
}) => {
  if (asAccordion) {
    return (
      <FlyAccordion
        trigger={
          <span className='font-bold text-size-fly-3 opacity-72'>{title}</span>
        }
        visibleContent={items[0]}
        className='flex flex-col gap-fly-4'
      >
        <div className='flex flex-col gap-fly-4'>{items.slice(1)}</div>
      </FlyAccordion>
    );
  }

  return (
    <div className='flex flex-col gap-fly-4 @card:p-fly-4'>
      <span className='font-bold pl-fly-2 text-size-fly-3 opacity-72'>
        {title}
      </span>
      {items}
    </div>
  );
};
